module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/pageBannerLarge-ae200eb8b36e011446291660d873bc63.png";